export default function isDateInFuture(date: string) {
  const currentDate = new Date();
  const inputDate = new Date(date);
  if (inputDate > currentDate) {
    return true;
  }
  return false;
}
